window.SLDS = window.SLDS || {};
window.SLDS.gallery = (images, aspect_ratio = '16:9') => ({
  images,
  aspect_ratio,
  activeIndex: 0,
  thumbStart: 0,
  visibleCount: 3,

  get activeImage() {
    return this.images[this.activeIndex] || {};
  },

  get visibleThumbnails() {
    return this.images
      .slice(this.thumbStart, this.thumbStart + this.visibleCount)
      .map((img, i) => ({
        ...img,
        index: this.thumbStart + i,
      }));
  },

  get showChevrons() {
    return this.images.length > 1;
  },

  setActive(index) {
    if (index < 0 || index >= this.images.length) return;
    this.activeIndex = index;

    if (index < this.thumbStart) {
      this.thumbStart = index;
    }
    if (index >= this.thumbStart + this.visibleCount) {
      this.thumbStart = index - this.visibleCount + 1;
    }
  },

  next() {
    this.setActive(this.activeIndex + 1);
  },

  prev() {
    this.setActive(this.activeIndex - 1);
  },
});
